import React,  { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { isEmpty } from 'check-tool';

import { getLanguage } from 'common/i18n';

import * as CONFIG from 'constants/config';

import MenuTop from 'components/MenuTop';
import MenuLeft from 'components/MenuLeft';
import Select from 'components/Select';
import { AuthContext } from 'AuthProvider';

import SubcategoryItem from 'pages/SubcategoriesPage/SubcategoryItem';

import { getCategoriesList } from 'backend/Category';
import { getSubcategoriesList, createSuccategory } from 'backend/Subcategory';

const SubcategoriesPage = () => {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [subcategoriesAll, setSubcategoriesAll] = useState([]);
  const [selectedValue, setSelectedValue] = useState('all');
  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAdd, setIsAdd] = useState(false);

  const [alias, setAlias] = useState('');
  const [isFree, setIsFree] = useState(true);
  const [categoryUid, setCategoryUid] = useState('all');

  const [nameEn, setNameEn] = useState('');
  const [nameRu, setNameRu] = useState('');
  const [nameUk, setNameUk] = useState('');
  const [namePl, setNamePl] = useState('');
  const [nameIt, setNameIt] = useState('');
  const [nameEs, setNameEs] = useState('');
  const [namePt, setNamePt] = useState('');

  const [leadEn, setLeadEn] = useState('');
  const [leadRu, setLeadRu] = useState('');
  const [leadUk, setLeadUk] = useState('');
  const [leadPl, setLeadPl] = useState('');
  const [leadIt, setLeadIt] = useState('');
  const [leadEs, setLeadEs] = useState('');
  const [leadPt, setLeadPt] = useState('');

  const lang = getLanguage();
  const { currentUser } = useContext(AuthContext);
  
  useEffect(() => {
    if (categories.length === 0) {
      getCategoriesList()
        .then((result) => {
          setCategories(result);
        })
        .catch((error) => {
          console.log('error', error);
          setCategories([]);
        });
    }
  }, [categories.length]);

  useEffect(() => {
    if (subcategories.length === 0) {
      getSubcategoriesList()
        .then((result) => {
          setSubcategoriesAll(result);
          const countPages = Math.ceil(result.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);
          setSubcategories(getSubcategoriesByPage(result));
        })
        .catch((error) => {
          console.log('error', error);
          setSubcategories([]);
          setSubcategoriesAll([]);
        });
    }
  }, []);

  useEffect(() => {
    setSubcategories(getSubcategoriesByPage(subcategoriesAll));
  }, [subcategoriesAll]);

  if (isEmpty(currentUser)) {
    return <Redirect to="/signin" />;
  }

  const selectCategory = (value) => {
    setSelectedValue(value);
    getSubcategoriesList()
      .then((result) => {
        if (value !== 'all') {
          let arr = [];
          result.map((element) => {
            if (element.categoryUid === value) {
              arr.push(element)
            }
          });
          const countPages = Math.ceil(arr.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);
          setSubcategories(getSubcategoriesByPage(arr));
          setSubcategoriesAll(arr);
          setCurrentPage(1);
        } else {
          const countPages = Math.ceil(result.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);
          setSubcategories(getSubcategoriesByPage(result));
          setSubcategories(result);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setSubcategories([]);
      });
  };

  const getSubcategoriesByPage = (items) => {
    let result = [];
    let i = 0;
    const fromPage = (currentPage - 1) * CONFIG.COUNT_PER_PAGE;
    const toPage = currentPage * CONFIG.COUNT_PER_PAGE;
    items.map((element) => {
      if (i >= fromPage && i < toPage) {
        result.push(element);
      }
      i++;
    })

    return result;
  };

  let pageBlock = [];
  if (pages > 1) {
    let arr = [];
    for (let i = 1; i <= pages; i++) {
      arr.push({page: i});
    }
    pageBlock = arr.map((element) => {
      if (currentPage === element.page) {
        return <button className="btn btn-light active" onClick={() => setCurrentPage(element.page)} key={element.page}>{element.page}</button>;
      } else {
        return <button className="btn btn-light" onClick={() => setCurrentPage(element.page)} key={element.page}>{element.page}</button>;
      }
    });
  }

  const clickOnAdd = () => {
    setIsAdd(true);
  };

  const onClickSave = () => {
    if (alias !== '' && categoryUid !== 'all') {
      createSuccategory(
        alias,
        isFree,
        categoryUid,
        nameEn,
        nameRu,
        nameUk,
        namePl,
        nameIt,
        nameEs,
        namePt,
        leadEn,
        leadRu,
        leadUk,
        leadPl,
        leadIt,
        leadEs,
        leadPt
      )
      .then(() => {
        setIsAdd(false);

        setNameEn('');
        setNameRu('');
        setNameUk('');
        setNamePl('');
        setNameIt('');
        setNameEs('');
        setNamePt('');

        setLeadEn('');
        setLeadRu('');
        setLeadUk('');
        setLeadIt('');
        setLeadPl('');
        setLeadEs('');
        setLeadPt('');

        getSubcategoriesList()
          .then((result) => {
            setSubcategoriesAll(result);
            const countPages = Math.ceil(result.length / CONFIG.COUNT_PER_PAGE);
            setPages(countPages);
            setSubcategories(getSubcategoriesByPage(result));
          })
          .catch((error) => {
            console.log('error', error);
            setSubcategories([]);
            setSubcategoriesAll([]);
          });
      })
      .catch((error) => {
        console.log('createSuccategory error', error);
      });
    } else {
      alert('Алиас и категория должны быть заполнены');
    }
  };

  const onClickCancel = () => {
    setIsAdd(false);
  };

  const onChangeText = (event, field) => {
    if (field === 'alias') setAlias(event.target.value);
    if (field === 'nameEn') setNameEn(event.target.value);
    if (field === 'nameRu') setNameRu(event.target.value);
    if (field === 'nameUk') setNameUk(event.target.value);
    if (field === 'namePl') setNamePl(event.target.value);
    if (field === 'nameIt') setNameIt(event.target.value);
    if (field === 'nameEs') setNameEs(event.target.value);
    if (field === 'namePt') setNamePt(event.target.value);

    if (field === 'leadEn') setLeadEn(event.target.value);
    if (field === 'leadRu') setLeadRu(event.target.value);
    if (field === 'leadUk') setLeadUk(event.target.value);
    if (field === 'leadPl') setLeadPl(event.target.value);
    if (field === 'leadIt') setLeadIt(event.target.value);
    if (field === 'leadEs') setLeadEs(event.target.value);
    if (field === 'leadPt') setLeadPt(event.target.value);
  };

  const checkboxOnChange = (value) => {
    setIsFree(!isFree);
  };

  const selectNewCategory = (value) => {
    setCategoryUid(value);
  };

  return (
    <div>
      <MenuTop lang={lang} user={currentUser} />
      <div className="main-container ace-save-state" id="main-container">
        <MenuLeft lang={lang} user={currentUser} currentPage="subcategories" />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="breadcrumbs ace-save-state" id="breadcrumbs">
              <ul className="breadcrumb">
                <li>
                  <i className="ace-icon fa fa-home home-icon"></i>
                  <a href="/">Главная</a>
                </li>
                <li className="active">Подкатегории</li>
              </ul>
            </div>
            <div className="page-content">
              {isAdd ? (
                <div className="row">
                  <div className="col-xs-12">
                    <table id="simple-table" className="table  table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>Алиас</th>
                          <th>Бесплатно?</th>
                          <th>Категория</th>
                          <th>EN</th>
                          <th>RU</th>
                          <th>UK</th>
                          <th>IT</th>
                          <th>PL</th>
                          <th>ES</th>
                          <th>PT</th>
                          <th></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>
                            <input
                              type="text"
                              id={'form-alias'}
                              placeholder="Алиас"
                              value={alias}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'alias')}
                            />
                          </td>
                          <td>
                            <label>
                              <input name="switch-field-1" className="ace ace-switch" type="checkbox" value={true} onChange={(value) => checkboxOnChange(value)} checked={isFree}  />
                              <span className="lbl" data-lbl="FREE        PAY"></span>
                            </label>
                          </td>
                          <td>
                            <Select items={categories} placeholder="Категории" onChange={(event) => selectNewCategory(event.target.value)} selectedValue={categoryUid} index={1} withAll={true} />  
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-nameEn'}
                              placeholder="Название (EN)"
                              value={nameEn}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'nameEn')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadEn'}
                              placeholder="Описание (EN)"
                              value={leadEn}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadEn')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-nameRu'}
                              placeholder="Название (RU)"
                              value={nameRu}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'nameRu')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadRu'}
                              placeholder="Описание (RU)"
                              value={leadRu}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadRu')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-nameUk'}
                              placeholder="Название (UK)"
                              value={nameUk}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'nameUk')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadUk'}
                              placeholder="Описание (UK)"
                              value={leadUk}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadUk')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-nameIt'}
                              placeholder="Название (IT)"
                              value={nameIt}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'nameIt')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadIt'}
                              placeholder="Описание (IT)"
                              value={leadIt}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadIt')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-namePl'}
                              placeholder="Название (PL)"
                              value={namePl}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'namePl')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadPl'}
                              placeholder="Описание (PL)"
                              value={leadPl}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadPl')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-nameEs'}
                              placeholder="Название (ES)"
                              value={nameEs}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'nameEs')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadEs'}
                              placeholder="Описание (ES)"
                              value={leadEs}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadEs')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-namePt'}
                              placeholder="Название (PT)"
                              value={namePt}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'namePt')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadPt'}
                              placeholder="Описание (PT)"
                              value={leadPt}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadPt')}
                            />
                          </td>
                          <td>
                          <button className="btn btn-success btn-xs" onClick={() => onClickSave()}>
                            <i className="ace-icon fa fa-save bigger-110 icon-only"></i>
                          </button>
                          &nbsp;&nbsp;
                          <button className="btn btn-grey btn-xs" onClick={() => onClickCancel()}>
                            <i className="ace-icon fa fa-reply bigger-110 icon-only"></i>
                          </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="row" style={{marginBottom: 10}}>
                  <div className="col-xs-12 text-right">
                    <button className="btn btn-success" onClick={() => clickOnAdd()}>Добавить</button>
                  </div>
                </div>
              )}
              <div className="row">
						  	<div className="col-xs-12">
								  <table id="simple-table" className="table  table-bordered table-hover">
									  <thead>
                      <tr>
                        <th>#</th>
                        <th>Алиас</th>
                        <th>
                          Категория
                          <br />
                          <Select
                            items={categories}
                            placeholder="Категории"
                            withAll={true}
                            onChange={(event) => selectCategory(event.target.value)}
                            selectedValue={selectedValue}
                          />
                        </th>
                        <th>Картинка</th>
                        <th>EN</th>
                        <th>RU</th>
                        <th>UK</th>
                        <th>IT</th>
                        <th>PL</th>
                        <th>ES</th>
                        <th>PT</th>
                        <th></th>
                      </tr>
									  </thead>

									  <tbody>
                      {subcategories.map((element, index) => {
                        const item = categories.find((x) => x.alias === element.categoryUid);
                        return <SubcategoryItem subcategory={element} key={index} index={index} categoryNameRu={item.name.ru} categories={categories} currentPage={currentPage} />
                      }
                      )}
                    </tbody>
								  </table>
                  <div className="btn-group">
                    {pageBlock}
                  </div>
							  </div>
							</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubcategoriesPage;